<ng-content select="lib-button"></ng-content>
<input #fileInput class="display-none" type="file" (change)="onFileSelect($event.target.files)" />
